import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import {PaymentMethodProps} from '../types';
import paymentMethodsKeys from '../util/payment-methods-keys';

export interface EditPaymentMethodProps
  extends Omit<PaymentMethodProps, 'id'> {}

const useEditPaymentMethod = (id: string) => {
  const {update} = useInfiniteQueryHelpers();
  const {setData} = useQueryHelpers();

  const onSuccess = (data: PaymentMethodProps) => {
    update(paymentMethodsKeys.list(), data);
    setData(paymentMethodsKeys.details(id), data);
  };

  return useApiMutation<EditPaymentMethodProps>({
    url: `/payment-methods/${id}`,
    method: 'PATCH',
    errorTitle: 'Erro ao editar forma de pagamento',
    successTitle: 'Editar forma de pagamento',
    successMessage: 'Forma de pagamento atualizada com sucesso',
    onSuccess,
  });
};

export default useEditPaymentMethod;
